import { render, staticRenderFns } from "./user-group.vue?vue&type=template&id=a7bfb10a&scoped=true&"
import script from "./user-group.vue?vue&type=script&lang=js&"
export * from "./user-group.vue?vue&type=script&lang=js&"
import style0 from "./user-group.vue?vue&type=style&index=0&id=a7bfb10a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bfb10a",
  null
  
)

export default component.exports